enum ClientRole {
  AIRQINO = 'airqino_testing',
  ADMIN = 'admin'
}

export default ClientRole;